import { useCallback } from "react";

import type { IUseInput } from "../types";

import classes from "../components/InputBlock/InputBlock.styl";

const HIDE_ANIMATION_DELAY = 200;

/**
 * Простой хук для управления инпутом
 * @param value - Переданное снаружи контролируемое значение инпута
 * @param onChange - Обработчик контролируемого значения инпута
 * @param ref
 */
export const useInput = ({ value, onChange, ref }: IUseInput) => {
    // Генерируем synthetic event для поля ввода с пустой строкой
    const clearInputHandler = useCallback(() => {
        const element = ref.current;

        if (!element) return;

        const isInput = element instanceof HTMLInputElement;
        const isTextarea = element instanceof HTMLTextAreaElement;

        if (!isInput && !isTextarea) return;

        const descriptor = Object.getOwnPropertyDescriptor(
            Object.getPrototypeOf(element),
            "value",
        );
        const nativeSetter = descriptor?.set;

        if (nativeSetter) {
            nativeSetter.call(element, "");
        }

        const event = new Event("input", { bubbles: true });
        element.dispatchEvent(event);
    }, [ref]);

    const showHidePassHandler = useCallback(() => {
        const currentRef = ref?.current;
        if (currentRef?.type) {
            currentRef.classList.add(classes["__hidden"]);
            setTimeout(() => {
                if (currentRef instanceof HTMLTextAreaElement) {
                    return;
                }
                if (currentRef.type === "password") {
                    currentRef.type = "text";
                } else {
                    currentRef.type = "password";
                }

                currentRef.classList.remove(classes["__hidden"]);
            }, HIDE_ANIMATION_DELAY);
        }
    }, [ref]);

    return {
        /** Контролируемое значение инпута */
        value,
        /** Обработчик изменения контролируемого значения инпута */
        onChange,
        /** Очищаем поле ввода */
        onClear: clearInputHandler,
        /** Показываем/скрываем пароль */
        onShowHide: showHidePassHandler,
    };
};
